import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';
import Vant from 'vant';
import 'ant-design-vue/dist/antd.css';
import 'vant/lib/index.css';
import req from './util/reqUtil'
import util from './util/Util'
import VueClipboard from 'vue-clipboard2'
import './assets/css/common.css'
import './assets/css/bookMark.css'
import vcolorpicker from 'vcolorpicker'

Vue.config.productionTip = false
Vue.use(Antd);
Vue.use(VueClipboard)
Vue.use(Vant);
Vue.use(vcolorpicker)

Vue.prototype.$req = req;
Vue.prototype.$util = util;

new Vue({
  router,
  store,
  components:{App},
  render: h => h(App)
}).$mount('#app')


